import React from 'react';
import ReactQuill from 'react-quill';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const MainContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  .ql-editor {
    overflow: auto;
    height: calc(48vh - 50px - 25px - 15vh);
    &::-webkit-scrollbar {
      width: 0.5em;
      height: 0.5em;
    }
    &::-webkit-scrollbar-track {
      background-color: #f2f2f2;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      border-radius: 0.5rem;
    }
  }
`;

const Editor = (props) => {
  const { upstream, sendData, placeholder } = props;

  const [state, setState] = React.useState({
    editorHtml: '',
  });

  const { editorHtml } = state;

  React.useEffect(() => {
    setState((prevState) => ({ ...prevState, editorHtml: upstream }));
  }, [upstream]);

  // // eslint-disable-next-line camelcase
  // const UNSAFE_componentWillMount() {
  //   const { upstream } = this.props;
  //   this.setState(() => ({
  //     editorHtml: upstream,
  //   }));
  // }

  const handleChange = (html) => {
    setState((prevState) => ({ ...prevState, editorHtml: html }));
    sendData(html);
  };

  return (
    <MainContainer>
      <ReactQuill
        theme="snow"
        onChange={handleChange}
        value={editorHtml}
        modules={Editor.modules}
        formats={Editor.formats}
        className="EditorComment"
        placeholder={placeholder}
      />
    </MainContainer>
  );
};

/*
 * Quill modules to attach to editor
 * See https://quilljs.com/docs/modules/ for complete options
 */
Editor.modules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'],
    [{ align: '' }, { align: 'center' }, { align: 'justify' }, { align: 'right' }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
    ['clean'],
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false,
  },
};
/*
 * Quill editor formats
 * See https://quilljs.com/docs/formats/
 */
Editor.formats = [
  'header',
  'font',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'align',
  'link',
];

Editor.propTypes = {
  upstream: PropTypes.string,
  placeholder: PropTypes.string,
  sendData: PropTypes.func,
  index: PropTypes.number,
};

Editor.defaultProps = {
  upstream: '',
  placeholder: '',
  sendData: () => {},
  index: 0,
};

export default Editor;
